module.exports = __webpack_public_path__ + "static/logo-a240b6f19b1af7f11e54c4f8f31c3bb5.png";